module.exports = __webpack_public_path__ + "img/fengmian.f85a0600.png";